module.exports = __webpack_public_path__ + "static/media/VAS_FEEDBACK_1_CLICKED.73211765.svg";